import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/constant';
import type { BookRow } from '../types';

export function useBookList(subjectId: number | null) {
  return useQuery({
    queryKey: ['exam_gen', 'books', subjectId],
    queryFn: () =>
      API.get<{ books: BookRow[] }>(
        `/api/textbook/list/?type=school&subject_id=${subjectId}`).then(r => r.data.books),
    enabled: !!subjectId,
  });
}
